// extending errors :
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error
// https://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript

function InvalidParameterError (publicMethodName, message) {
  this.name = 'InvalidParameterError'
  this.message = publicMethodName + ' - ' + message
  this.stack = (new Error()).stack
}
InvalidParameterError.prototype = Object.create(Error.prototype)
InvalidParameterError.prototype.constructor = InvalidParameterError

function QueueError (message) {
  this.name = 'QueueError'
  this.message = message
  this.stack = (new Error()).stack
}
QueueError.prototype = Object.create(Error.prototype)
QueueError.prototype.constructor = QueueError

function MissingCoreParameterError (name) {
  this.name = 'MissingCoreParameterError'
  this.message = 'missing ' + name
  this.stack = (new Error()).stack
}
MissingCoreParameterError.prototype = Object.create(Error.prototype)
MissingCoreParameterError.prototype.constructor = MissingCoreParameterError

export { InvalidParameterError, QueueError, MissingCoreParameterError }



// WEBPACK FOOTER //
// ./src/initializers/Errors.js